import script from "./SettingsSubDepartmentsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsSubDepartmentsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsSubDepartmentsSection.vue?vue&type=style&index=0&id=6c296d0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c296d0c"]])

export default __exports__